import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SEOWrapper } from './components/common/SEO';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { ScrollToTop } from './components/common/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsPage } from './pages/TermsPage';
import { ChildSafetyPage } from './pages/ChildSafetyPage';
import { ReferralPage } from './pages/ReferralPage';
import { DemoPage } from './pages/DemoPage';
import { AccountDeletionPage } from './pages/AccountDeletionPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { RefundPolicyPage } from './pages/RefundPolicyPage';
import { CommunityGuidelinesPage } from './pages/CommunityGuidelinesPage';
import { SharePage } from './pages/SharePage';

function App() {
  return (
    <ErrorBoundary>
      <SEOWrapper>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/terms-of-use" element={<Navigate to="/terms" replace />} />
            <Route path="/community-guidelines" element={<CommunityGuidelinesPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
            <Route path="/child-safety" element={<ChildSafetyPage />} />
            <Route path="/account-deletion" element={<AccountDeletionPage />} />
            <Route path="/referral-register" element={<ReferralPage />} />
            <Route path="/share" element={<SharePage />} />
            <Route path="/share/:shareKind/:shareId" element={<SharePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
      </SEOWrapper>
    </ErrorBoundary>
  );
}

export default App;
